import { useMemo } from "react";
import { useQuery } from "@rocicorp/zero/react";
import { queries } from "@/lib/queries";

/**
 * Returns a Set of user IDs that the current user already has a 1:1 DM with.
 * Shared hook — consumed by Sidebar for the NewDM dialog.
 */
export function useExistingDmUserIds(
  userId: string | undefined,
  enabled: boolean,
) {
  const [dmsRaw] = useQuery(
    enabled && userId ? queries.channels.dmsByUserWithMembers() : null,
  );
  return useMemo(() => {
    const ids = new Set<string>();
    for (const ch of dmsRaw ?? []) {
      if (ch.type === "dm") {
        for (const m of ch.members ?? []) {
          if (m.user_id !== userId) ids.add(m.user_id);
        }
      }
    }
    return ids;
  }, [dmsRaw, userId]);
}
